import React from 'react';
import Collapsible from '../Components/Collapsible';
import { EditorStringModel } from '../Types/EditorString';
import EditorString from '../Components/EditorString/EditorString';

interface FaqAccordionProps {
  systemId: string;
  title: string;
  faqItems: FaqAccordionItem[];
}

interface FaqAccordionItem {
  title?: string;
  text?: EditorStringModel;
}

const FaqAccordion = (props: FaqAccordionProps) => {
  const faqList = props.faqItems;

  return (
    <div className="container flex flex-col items-center">
      {faqList.map((faq) => (
        <Collapsible
          className="w-full max-w-3xl bg-gray-100 [&:last-child]:border-0 [&:not(:last-child)]:mb-2 [&_.ReactCollapse--content]:border [&_.ReactCollapse--content]:border-t-0 [&_.ReactCollapse--content]:border-solid [&_.ReactCollapse--content]:border-gray-100 [&_.ReactCollapse--content]:bg-white [&_.ReactCollapse--content]:p-4 [&_.ReactCollapse--content]:text-lg [&_.collapsible]:border-0 [&_.icon-wrapper]:h-10 [&_.icon-wrapper]:w-10 [&_.icon-wrapper]:bg-primary-500 [&_.icon]:h-6 [&_.icon]:w-6 [&_label]:p-2 [&_label]:pl-4"
          key={faq.title}
          label={faq.title}
        >
          <EditorString value={faq.text?.value} />
        </Collapsible>
      ))}
    </div>
  );
};

export default FaqAccordion;
